import styles from './body-part-filter-tree.module.css'
import { BodyPartFilterModel } from './body-part-util'
import { Checkbox } from '../../ui/checkbox'
import { ChevronSvgIcon } from '../../util/images'
import { FilterItemButton } from '../filter-item-button'
import React, { useState } from 'react'

export function BodyPartFilterTree(props: {
  root: BodyPartFilterModel
  selectedParts: string[]
  handleOnToggle: (id: string) => void
  treeDepth: number
}): React.ReactElement {
  const { root, selectedParts, handleOnToggle, treeDepth } = props

  const getBodyPartFilterChild = (child: BodyPartFilterModel): React.ReactElement => {
    return (
      <BodyPartFilterChild
        key={child.id}
        root={child}
        selectedParts={selectedParts}
        handleOnToggle={handleOnToggle}
        treeDepth={treeDepth}
        level={1}
      />
    )
  }

  return (
    <div>
      <FilterItemButton isActive={selectedParts.includes(root.id)} onClick={() => handleOnToggle(root.id)}>
        <span className="font-roboto font-semibold text-xs leading-4 tracking-[0.5px] text-[#C5C5C5] uppercase">
          {root.label}
        </span>
      </FilterItemButton>
      {/*      <div
        className={`${filterStyles.filterItemButton} ${styles.rootButton} ${
          selectedParts.includes(root.id) ? filterStyles.filterItemActiveButton : ''
        }`}
        onClick={() => handleOnToggle(root.id)}
      >
      </div>*/}
      <div className={styles.subFiltersContainer}>{root.subFilters.map((child) => getBodyPartFilterChild(child))}</div>
    </div>
  )
}

export function BodyPartFilterChild(props: {
  root: BodyPartFilterModel
  selectedParts: string[]
  handleOnToggle: (id: string) => void
  treeDepth: number
  level: number
}): React.ReactElement {
  const { root, selectedParts, handleOnToggle, treeDepth, level } = props
  const [isOpen, setOpen] = useState(false)
  const handleToggleOpen = (): void => {
    if (root.subFilters.length < 1) return
    setOpen((open) => !open)
  }

  const getBodyPartFilterChild = (child: BodyPartFilterModel): React.ReactElement => {
    return (
      <BodyPartFilterChild
        key={child.id}
        root={child}
        selectedParts={selectedParts}
        handleOnToggle={handleOnToggle}
        treeDepth={treeDepth}
        level={level + 1}
      />
    )
  }

  return (
    <div className={level === 1 ? 'border-b border-tertiary-grey' : ''}>
      <div className="d-flex justify-content-between items-center">
        <div className="flex items-center gap-2 py-2">
          <Checkbox
            checked={selectedParts.includes(root.id) ?? false}
            onCheckedChange={() => handleOnToggle(root.id)}
            id={`checkbox-${root.id}`}
            className="h-6 w-6 border-2 !border-tertiary-grey data-[state=checked]:!border-primary data-[state=checked]:bg-primary data-[state=checked]:text-ivory"
          />
          <label
            className="font-roboto-condensed text-base leading-6 tracking-[0.5px] text-white cursor-pointer mb-0"
            htmlFor={`checkbox-${root.id}`}
          >
            {root.label}
          </label>
        </div>
        {level < treeDepth && (
          <span onClick={handleToggleOpen}>
            <ChevronSvgIcon
              className={`${isOpen ? styles.chevronOpen : ''} ${root.subFilters.length ? '' : styles.chevronDisabled}`}
            />
          </span>
        )}
      </div>
      {isOpen && (
        <div className={styles.subFiltersContainer}>{root.subFilters.map((child) => getBodyPartFilterChild(child))}</div>
      )}
    </div>
  )
}
